module.exports = __webpack_public_path__ + "static/media/scroll-old.daf09cfc.svg";